import { render, staticRenderFns } from "./ProductQuickEditPrice.vue?vue&type=template&id=6f540146&scoped=true"
import script from "./ProductQuickEditPrice.vue?vue&type=script&lang=ts"
export * from "./ProductQuickEditPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f540146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f540146')) {
      api.createRecord('6f540146', component.options)
    } else {
      api.reload('6f540146', component.options)
    }
    module.hot.accept("./ProductQuickEditPrice.vue?vue&type=template&id=6f540146&scoped=true", function () {
      api.rerender('6f540146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductQuickEditPrice.vue"
export default component.exports